document.addEventListener("DOMContentLoaded", function () {
  // Lấy phần tử menu chính
  const menu = document.querySelector('.mobile-slideout-menu');
  if (!menu) return;

  menu.addEventListener('click', function(e) {
    // Mở submenu khi click vào vùng menu cha (trừ <a>)
    if (
      e.target.classList.contains('navigation-mobile-item-link-expand') ||
      (e.target.closest('.navigation-mobile-item-link-expand'))
    ) {
      const parent = e.target.closest('.navigation-mobile-item');
      const btn = parent.querySelector('[data-next]');
      if (btn) {
        // Tìm panel con và mở ra
        const nextPanel = btn.getAttribute('data-next');
        const panel = menu.querySelector(`[data-panel="${nextPanel}"]`);
        if (panel) panel.classList.add('is-active');
        e.preventDefault();
        return;
      }
    }
    // Đóng tất cả panel khi click nút đóng
    if (e.target.closest('[data-close]')) {
      menu.querySelectorAll('.slide-panel.is-active').forEach(panel => {
        panel.classList.remove('is-active');
      });
    }

    // Quay lại 1 cấp khi click nút back
    if (e.target.closest('[data-back]')) {
      const current = e.target.closest('.slide-panel');
      if (current) current.classList.remove('is-active');
    }
  });
});